import {css} from "@emotion/css";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import {RouteInfo} from "../../route/RouteHelper";
import React, {useEffect} from "react";
import RaikoCustomTable from "../../raikoComponents/raikoCustomTable/RaikoCustomTable";
import {useState} from "react";
import RaikoDefaultDialogPage from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import ShowThisMessage from "../../component/ShowThisMessage/ShowThisMessage";
import {Helmet} from "react-helmet";
import {ContactUsService} from "../../serverService/contactUsService/ContactUsService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import RaikoCustomSimpleActiveDeActiveChip
    from "../../raikoComponents/raikoCustomChip/raikoCustomSimpleActiveDeactiveChip/RaikoCustomSimpleActiveDeActiveChip";
import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";

const ContactUsList = () => {
    let page = 0;
    const size = 15

    const service = new ContactUsService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getDataFromServer()
        }
    }, []);


    const [messageList, setMessageList] = useState([])


    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0);

    const [openModal, setOpenModal] = useState(false)

    function handleShowMessage(rowId) {
        setSelectedItemId(rowId)
        setOpenModal(true)
    }

    function handleCloseModal() {
        setOpenModal(false)
    }

    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function prepareTableRow(id, number, title, fullName, phoneNumber, sendAt, status) {
        return {
            id,
            number,
            subject: title,
            fullName,
            phoneNumber,
            date: convertUniversalDateToPersianDate(sendAt),
            status: <RaikoCustomSimpleActiveDeActiveChip
                deActiveStateTitle={"بررسی نشده"}
                activeStateTitle={"بررسی شده"}
                state={status === "REVIEWED"}/>
        }
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getMessageList(page, size)
            .then(response => {

                setPageCount(response.totalPage)
                setMessageList([])
                response.data.map((item, index) => {
                    setMessageList(prevState => [
                        ...prevState,
                        prepareTableRow(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            `${item.firstName} ${item.lastName}`,
                            item.phoneNumber,
                            item.sendAt,
                            item.status
                        )
                    ])
                })

                setTableLoading(false)
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage("خطا در دریافت لیست پیام ها"))
            setTableLoading(false)
        })
    }

    const [selectedItemId, setSelectedItemId] = useState(-1);

    return (

        <>
            <Helmet>
                <title>{RouteInfo.ContactUsList.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                pageTitle={"جزئیات پیام"}
                onClose={handleCloseModal}
                open={openModal}
            >
                <ShowThisMessage id={selectedItemId}/>
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>

                <RaikoBreadcrumb
                    breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            "روابط عمومی",
                            RouteInfo.ContactUsList.globalUrl
                        ),
                        raikoBreadCrumbItemGenerator(
                            "تماس با ما",
                            ""
                        ),
                    ]}/>

                <RaikoGridOneColumn className={`${css`
                  margin-top: 40px;
                `}`}>

                    <RaikoBaseCardContainer>
                        <RaikoCustomTable
                            isLoading={tableLoading}
                            data={messageList}
                            header={column}
                            pageCount={pageCount}
                            handlePaginationChange={handlePagination}
                            rowClicked={handleShowMessage}
                        />
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>

            </RaikoBaseContainer>
        </>

    )
}
export default ContactUsList;

const column = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'subject',
        label: 'موضوع',
    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی'
    },
    {
        id: "phoneNumber",
        label: "شماره همراه"
    },
    {
        id: "date",
        label: "تاریخ"
    },
    {
        id: "status",
        label: "وضعیت"
    },
]